import React, { Children } from 'react';
import { Star, Quote, Clock, MapPin, Briefcase } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const testimonials = [{
  name: 'Laura P.',
  age: '31 años',
  location: 'Houston, TX',
  role: 'Gestión de Redes',
  hook: '$520 en 18 días — sin inglés, sin contactos',
  quote: 'Llegué a este país sin contactos, sin inglés y con miedo de no poder salir adelante. En 18 días con este método hice mis primeros $520 gestionando redes para negocios latinos en mi ciudad.',
  result: '18 días'
}, {
  name: 'Paola R.',
  age: '35 años',
  location: 'Orlando, FL',
  role: 'Atención al Cliente',
  hook: '$680 primer mes — siendo mamá y trabajando de noche',
  quote: 'Soy mamá, trabajo de noche y no tenía tiempo para nada. Seguí el método paso a paso y en 3 semanas ya tenía 2 clientes fijos. Este mes cerré $680 — todo desde mi teléfono.',
  result: '3 semanas'
}, {
  name: 'Valeria V.',
  age: '33 años',
  location: 'Dallas, TX',
  role: 'Asistente Virtual',
  hook: 'Primer cliente en 10 días — $590 en un mes',
  quote: 'Pensé que era otro curso más. Me equivoqué. En 10 días conseguí mi primer cliente y en un mes ya había facturado $590. Sin inglés, sin experiencia, sin oficina.',
  result: '10 días'
}, {
  name: 'Camila S.',
  age: '28 años',
  location: 'Los Angeles, CA',
  role: 'Moderadora de Redes',
  hook: '$510 trabajando solo 2 horas al día',
  quote: 'Llevaba 2 años queriendo empezar algo propio. Este método me lo hizo fácil. Primera semana, primer cliente. Primer mes: $510 trabajando solo 2 horas al día.',
  result: '7 días'
}, {
  name: 'María G.',
  age: '34 años',
  location: 'Miami, FL',
  role: 'Atención al Cliente',
  hook: '$340 en menos de 2 semanas — primer cliente en 24 horas',
  quote: 'Lo compré un domingo y el lunes ya tenía mi primer cliente por WhatsApp. En menos de 2 semanas ya había hecho $340 — sin inglés, sin salir de casa.',
  result: '24 horas'
}];
function StarRating() {
  return <div className="flex gap-0.5" data-id="element-828">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#b8956a] fill-[#b8956a]" data-id="element-829" />)}
    </div>;
}
export function Testimonials() {
  return <section className="py-12 md:py-16 px-4 md:px-6 bg-[#faf6f1] relative overflow-hidden" data-id="element-830">
      <div className="absolute top-0 right-0 w-80 h-80 bg-[#e0bfb4] opacity-15 rounded-full blur-3xl md:blur-[120px] translate-x-1/3 -translate-y-1/3 pointer-events-none hidden md:block" data-id="element-831" />

      <div className="max-w-5xl mx-auto animate-hero-fade-in" data-id="element-832">
        {/* Social proof bar */}
        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-833">
          <StarRating data-id="element-834" />
          <p className="text-sm md:text-base text-[#6b5744] font-medium" data-id="element-835">
            Más de 1,200 mujeres latinas ya están usando este mapa para cobrar
            en dólares desde casa.
          </p>
        </div>

        {/* Section title */}
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-[#3d2b1f] mb-4 max-w-3xl mx-auto leading-tight" data-id="element-836">
          Ellas no tenían experiencia. Tampoco inglés. Solo tenían su español y
          este mapa.
        </h2>
        <p className="text-center text-[#9a8b7a] text-sm font-medium mb-12" data-id="element-837">
          Lo que dicen las que ya tienen el mapa:
        </p>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-838">
          {testimonials.map((t, index) => <div key={index} className="bg-white rounded-3xl p-6 md:p-7 shadow-sm border border-[#e0bfb4]/30 flex flex-col" data-id="element-839">
              {/* Quote icon */}
              <div className="mb-4" data-id="element-840">
                <div className="w-10 h-10 rounded-full bg-[#b8956a]/10 flex items-center justify-center" data-id="element-841">
                  <Quote className="w-5 h-5 text-[#b8956a]" data-id="element-842" />
                </div>
              </div>

              {/* Hook headline */}
              <h3 className="text-lg font-bold text-[#3d2b1f] mb-3 leading-snug" data-id="element-843">
                "{t.hook}"
              </h3>

              {/* Full testimonial */}
              <p className="text-[#6b5744] text-sm leading-relaxed italic mb-5 flex-1" data-id="element-844">
                "{t.quote}"
              </p>

              {/* Divider */}
              <div className="border-t border-[#e0bfb4]/40 pt-4 mt-auto" data-id="element-845">
                {/* Name + Location */}
                <div className="flex items-start justify-between mb-3" data-id="element-846">
                  <div data-id="element-847">
                    <p className="font-bold text-[#3d2b1f] text-sm" data-id="element-848">
                      — {t.name}, {t.age}
                    </p>
                    <div className="flex items-center gap-3 mt-1.5" data-id="element-849">
                      <div className="flex items-center gap-1" data-id="element-850">
                        <MapPin className="w-3.5 h-3.5 text-[#9a8b7a]" data-id="element-851" />
                        <span className="text-xs text-[#9a8b7a]" data-id="element-852">
                          {t.location}
                        </span>
                      </div>
                      <div className="flex items-center gap-1" data-id="element-853">
                        <Briefcase className="w-3.5 h-3.5 text-[#b8956a]" data-id="element-854" />
                        <span className="text-xs font-medium text-[#b8956a]" data-id="element-855">
                          {t.role}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rating + Result */}
                <div className="flex items-center justify-between" data-id="element-856">
                  <StarRating data-id="element-857" />
                  <div className="flex items-center gap-1.5" data-id="element-858">
                    <Clock className="w-3.5 h-3.5 text-[#7a9a6b]" data-id="element-859" />
                    <span className="text-xs font-bold text-[#7a9a6b]" data-id="element-860">
                      Resultado en: {t.result}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}